export default {
  errors: {
    emailAlreadyRegistered: 'Email già registrata, prova ad accedere.',
    invalidEmail: 'Email non valida, riprova.'
  },
  title: 'Registrati',
  subtitle: 'Crea un nuovo account Vamoz',
  success: {
    title: 'Controlla la tua email ✉️',
    message:
      "Ti abbiamo inviato un'email con un link per verificare il tuo account. L'email potrebbe impiegare alcuni minuti per arrivare. Controlla anche la cartella spam."
  },
  confirmation: {
    confirmed: {
      title: 'Email confermata!',
      message:
        'Il tuo indirizzo email è stato confermato. Ora puoi accedere a Vamoz.'
    },
    alreadyConfirmed: {
      title: 'Link già utilizzato',
      message:
        'Questo link di conferma è già stato utilizzato o è in fase di elaborazione. Se il tuo account è pronto, puoi accedere qui sotto.'
    },
    expired: {
      title: 'Link di conferma scaduto',
      message:
        "Torna al link di registrazione della tua azienda e inserisci nuovamente l'email. Contatta l'amministratore aziendale se non hai più il link."
    },
    invalid: {
      title: 'Link di conferma non valido',
      message:
        "Apri l'ultima email di conferma ricevuta o richiedine una nuova dal link di registrazione della tua azienda."
    },
    unavailable: {
      title: 'Conferma temporaneamente non disponibile',
      message:
        'Riprova questo link tra qualche minuto. Contatta il supporto se il problema persiste.'
    }
  },
  goToLogin: 'Vai al login',
  button: 'Registrati',
  allowedDomains: 'Domini consentiti: {domains}',
  help: 'Aiuto',
  instructions: {
    title: 'Istruzioni per la registrazione',
    subtitle: 'Segui questi tre passaggi per registrarti su Vamoz.',
    step1: 'Inserisci il tuo indirizzo email (da un dominio consentito)',
    step2:
      'Controlla la tua email (potrebbe richiedere alcuni minuti per arrivare)',
    step3: "Clicca sul link nell'email per confermare il tuo indirizzo email",
    spamFolder:
      "Se non vedi l'email nella tua casella di posta, controlla la cartella spam."
  }
};
